/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class InterpretationValidateService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.INTERPRETATION_VALIDATE_LIST_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServicePath.INTERPRETATION_GET_BY_ID, params);
}
static getImagebyStudy(params){
  return this.postSEC(ServicePath.STUDY_FIND_ALL_IMAGES_BY_STUDY, params);
} 
  static update(params) {
    return this.postSEC(ServicePath.INTERPRETATION_VALIDATE, params);
  }
  static getAddendums(params) {
    return this.postSEC(ServicePath.INTERPRETATION_GET_ADDENDUMS, params);
}
}
